import { NotebookActionKey } from "../../../../actions/ActionKeys";
import { NotebookAction } from "../../../../actions/notebook";

/** Either sets error or clears it when a title change comes in. */
export const title = (
  state: Error | null = null,
  action: NotebookAction
): Error | null => {
  switch (action.type) {
    case NotebookActionKey.SET_TITLE:
      return action.payload.error;
    default:
      return state;
  }
};
